import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SharedModule } from 'app/shared';
import { getNotifications } from './notifications.reducer';


@Component({
    selector: 'notifications-dropdown-header',
    imports: [
        SharedModule,
    ],
    template: `
        <div class="d-flex align-items-center">
            <div class="h4 mb-0">
                <ng-content></ng-content>
            </div>
            <div class="ml-auto"></div>
            <button class="btn btn-transparent ml-2" title="Close" (click)="close()">
                <img src="/assets/images/ui/close.svg">
            </button>
        </div>
        <div class="border-bottom mt-2 mb-2"></div>
    `,
})
export class NotificationsDropdownHeaderComponent {

    private router = inject(Router);

    private store = inject(Store);

    notifications = toSignal(this.store.select(getNotifications), { initialValue: [] });

    close() {
        this.router.navigate([{ outlets: { notifications: null } }]);
    }
}
